export default [
    {
        path: '/transport',
        name: 'Transport',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/fleet/FleetIndex.vue'),
        },
    },
    {
        path: '/transport/create',
        name: 'TransportCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            title: 'Create transport',
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/fleet/FleetCreate.vue'),
        },
    },
    {
        path: '/transport/:id/edit',
        name: 'TransportEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            title: 'Edit transport',
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/fleet/FleetEdit.vue'),
        },
    },
];
